import {createContext,useContext} from "react";

export const CredencialContext = createContext({});
export function useCredencial() {
    return useContext(CredencialContext);
}
